module.exports = __webpack_public_path__ + "images/file_icons_v2/py-7144141f0e9689ef065b8874ba0d1cfe.svg";